export default __webpack_public_path__ + "static/media/comfort.34d8bc0b.png";